import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const slot = css`
  & + &:before {
    inset-inline-start: ${spacing(2)};
    inset-inline-end: ${spacing(2)};
  }
`
export const suggestTrail = css`
  flex: initial;
`
